import { render, staticRenderFns } from "./SmetaTab.vue?vue&type=template&id=83a1d060"
import script from "./js/smetaTab.js?vue&type=script&lang=js&external"
export * from "./js/smetaTab.js?vue&type=script&lang=js&external"
import style0 from "./SmetaTab.vue?vue&type=style&index=0&id=83a1d060&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports